import { FC, useContext } from "react";
import { MessageStatus } from 'botframework-directlinejs';
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import useStyleToEmotionObject from 'botframework-webchat-component/lib/hooks/internal/useStyleToEmotionObject';
import classNames from "classnames";
import { useMergedOptions } from '../selectors/useMergedOptions';
// import useStyleOptions from "botframework-webchat/lib/hooks/useStyleOptions";
import { hooks } from 'botframework-webchat-api';


const { useDirection, useStyleOptions } = hooks;
const DruidActivityStatus:  FC<{status: number, className: string, activityStatusReadColor: Nullable<string>}> = (({ status, className, activityStatusReadColor }) => {
    const [druidWebChatState,,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const [direction] = useDirection();

    const [{ subtle, accent }] = useStyleOptions();
    // const { UI: { activityStatusReadColor }  = {},  } = useMergedOptions();



    const styleToEmotionObject = useStyleToEmotionObject();
    const ROOT_STYLE = {}[`&.${className}`] = {
        display: 'flex',
        margin: 'auto',
        '> svg.druid-icon-check': {
          '&.druid-icon-check-read': {
              color: activityStatusReadColor || accent
          },
          '&.druid-icon-check-delivered': {
              color: subtle
          },
          '&.druid-icon-check-sent': {
            //   color: 'red'
          }
        }
      };
    
    const rootClassName = styleToEmotionObject(ROOT_STYLE) + '';

    const svgStyle = { height: '15px', marginLeft: direction === 'ltr' ? '3px' : undefined, marginRight: direction === 'rtl' ? '3px' : undefined, width: '15px' };
    return druidWebChatState.directlineOptions?.isBotApiEnabled ? 
            (<span className={classNames(rootClassName + '', (className || '') + '')}>
               
                {
                    status > 1 ?
                        <svg style={svgStyle} className={`druid-icon-check ${status === MessageStatus.Read ? 'druid-icon-check-read' : 'druid-icon-check-delivered'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
                        : <svg style={svgStyle} className="druid-icon-check druid-icon-check-sent" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"></path></svg>
                }
            </span>
            ) 
            : (null);
});

export default DruidActivityStatus;